var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [_vm.from ? "" : "app-main-inner"] }, [
    _c("div", { staticClass: "section" }, [
      _c("span", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("SeaExport.Warehouse2")))
      ]),
      _c(
        "div",
        { staticClass: "warehouse-wrap" },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                "label-width": "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.LoadingCharge2") }
                },
                [
                  _c("el-input-number", {
                    attrs: {
                      no: "1",
                      disabled: !_vm.chargeEnable,
                      precision: 2,
                      min: 0,
                      max: 999999999999,
                      "controls-position": "right"
                    },
                    on: { change: _vm.dealPackingCharge },
                    model: {
                      value: _vm.packingChargeAmount,
                      callback: function($$v) {
                        _vm.packingChargeAmount = $$v
                      },
                      expression: "packingChargeAmount"
                    }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.localCurrency))]),
                  _vm.isZh
                    ? [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.RmbNumberOfDamagedAndDamp")
                            )
                          )
                        ]),
                        _c("el-input-number", {
                          attrs: {
                            no: "2",
                            value:
                              _vm.warehouseInfo.quantity === 0
                                ? undefined
                                : _vm.warehouseInfo.quantity,
                            precision: 0,
                            min: 0,
                            max: 999999999999,
                            "controls-position": "right"
                          },
                          on: {
                            input: function(val) {
                              _vm.warehouseInfo.quantity = val
                            }
                          }
                        })
                      ]
                    : _vm._e()
                ],
                2
              ),
              !_vm.isZh
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: _vm.$t("SeaExport.RmbNumberOfDamagedAndDamp2")
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "3",
                          value:
                            _vm.warehouseInfo.quantity === 0
                              ? undefined
                              : _vm.warehouseInfo.quantity,
                          precision: 0,
                          min: 0,
                          max: 999999999999,
                          "controls-position": "right"
                        },
                        on: {
                          input: function(val) {
                            _vm.warehouseInfo.quantity = val
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { label: _vm.warehouseCmpLabel }
                },
                [
                  _c("cargo-company-select", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "4",
                      "method-params": { warehouse: true, active: true },
                      "default-value": _vm.warehouseInfo.warehouseCmp || ""
                    },
                    on: {
                      change: function(p) {
                        _vm.warehouseInfo.warehouseCmp = p.value || 0
                        _vm.warehouseChangeHandler(p.value)
                      }
                    }
                  })
                ],
                1
              ),
              _vm.openWarehouse
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.WareHouseName") }
                    },
                    [
                      _vm.openWarehouse
                        ? _c(
                            "el-select",
                            {
                              ref: "advanceSelectRef",
                              staticStyle: { width: "400px" },
                              attrs: {
                                no: "5",
                                "allow-create": true,
                                filterable: "",
                                clearable: true
                              },
                              on: {
                                change: _vm.nameChangeHandler,
                                "visible-change": _vm.onVisibleChange
                              },
                              model: {
                                value: _vm.warehouseInfo.warehouseName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.warehouseInfo,
                                    "warehouseName",
                                    $$v
                                  )
                                },
                                expression: "warehouseInfo.warehouseName"
                              }
                            },
                            _vm._l(_vm.warehouseNameList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.warehouseName,
                                  value: item.warehouseName
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.WarehouseAddress") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { no: "6", type: "textarea", rows: 5 },
                    model: {
                      value: _vm.warehouseInfo.warehouseAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.warehouseInfo, "warehouseAddress", $$v)
                      },
                      expression: "warehouseInfo.warehouseAddress"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                "label-width": "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.ContactWay") } },
                [
                  _vm.openWarehouse
                    ? _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: { no: "7" },
                        model: {
                          value: _vm.warehouseInfo.warehouseContact,
                          callback: function($$v) {
                            _vm.$set(_vm.warehouseInfo, "warehouseContact", $$v)
                          },
                          expression: "warehouseInfo.warehouseContact"
                        }
                      })
                    : _vm._e(),
                  !_vm.openWarehouse
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { width: "400px" },
                          attrs: {
                            no: "8",
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                            "allow-create": true,
                            clearable: true,
                            filterable: ""
                          },
                          on: {
                            change: _vm.contactsChangeHandler,
                            blur: _vm.selectContactBlur
                          },
                          model: {
                            value: _vm.warehouseInfo.warehouseContact,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.warehouseInfo,
                                "warehouseContact",
                                $$v
                              )
                            },
                            expression: "warehouseInfo.warehouseContact"
                          }
                        },
                        _vm._l(_vm.contactList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.contactPerson,
                              value: item.contactPerson
                            }
                          })
                        }),
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Tel") } },
                [
                  _c("el-input", {
                    attrs: { no: "9" },
                    model: {
                      value: _vm.warehouseInfo.warehouseContactTel,
                      callback: function($$v) {
                        _vm.$set(_vm.warehouseInfo, "warehouseContactTel", $$v)
                      },
                      expression: "warehouseInfo.warehouseContactTel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.CargosExpectedArrivalDate")
                  }
                },
                [
                  _c("el-date-picker", {
                    ref: "arriveDate",
                    staticStyle: { width: "400px" },
                    attrs: {
                      no: "10",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      blur: function() {
                        _vm.handleBlur(
                          "arriveDate",
                          null,
                          true,
                          true,
                          _vm.warehouseInfo
                        )
                      }
                    },
                    model: {
                      value: _vm.warehouseInfo.arriveDate,
                      callback: function($$v) {
                        _vm.$set(_vm.warehouseInfo, "arriveDate", $$v)
                      },
                      expression: "warehouseInfo.arriveDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.LoadingRemarks") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { no: "11", type: "textarea", rows: 5 },
                    model: {
                      value: _vm.warehouseInfo.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.warehouseInfo, "remarks", $$v)
                      },
                      expression: "warehouseInfo.remarks"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }